export class SignalrTrackingData {
  public Area: string;
  public AreaID: number;
}
